import { RequestService } from '../../../../../common/services/RequestService';
import { USER_FILTER_VEHICLES_GET } from '../../constants';
import { vehiclesFilterRequestStr } from '../../../../../common/utils/format';

export const getUserFilterVehiclesRequest = payload => {
  const { filtersArray, includeStatusKey } = payload;
  const requestStr = vehiclesFilterRequestStr(filtersArray);

  return RequestService.get(
    `${USER_FILTER_VEHICLES_GET}?${includeStatusKey}${requestStr && requestStr}`
  );
};
